var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.internalComments.length > 0
    ? _c(
        "div",
        { staticClass: "annotate" },
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { hit: "", shadow: "" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("el-switch", {
                    staticStyle: { float: "right", padding: "3px 0" },
                    attrs: {
                      "active-text": "Έμφάνιση",
                      "inactive-text": "Αποκρυψη"
                    },
                    model: {
                      value: _vm.showComments,
                      callback: function($$v) {
                        _vm.showComments = $$v
                      },
                      expression: "showComments"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Εσωτερικά σχόλια")])
                ],
                1
              ),
              _vm._v(" "),
              _vm.showComments
                ? _c(
                    "div",
                    { staticClass: "text item" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.internalComments }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Ονοματεπώνυμο", width: "140" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [_vm._v(_vm._s(scope.row.name))])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Ρόλος", width: "140" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.translate(scope.row.role))
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Ημερομηνία", width: "160" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.dateCompleted
                                            ? scope.row.dateCompleted.substring(
                                                0,
                                                16
                                              )
                                            : ""
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Σχόλιο", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          trigger: "click",
                                          placement: "top-start",
                                          title: "Σχόλιο: ",
                                          width: "400"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { color: "blue" },
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.internalComment.substring(
                                                  0,
                                                  20
                                                )
                                              ) + "..."
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.internalComment)
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af5c2e3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af5c2e3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/internalComments.vue
// module id = null
// module chunks = 